import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { PhoneNumber } from "../../../../views/marketing-pages/channels/voice/types";

export const PhoneNumberStep: React.FC<{
  onContinue: (number: string) => void;
}> = ({ onContinue }) => {
  const [selectedNumber, setSelectedNumber] = useState<string>("");
  const [country, setCountry] = useState<string>("India");
  const [phoneNumbers, setPhoneNumbers] = useState<PhoneNumber[]>([]);

  // Define phone number pools for each country
  const countryPhoneNumbers: Record<string, PhoneNumber[]> = {
    India: [
      { id: "1", number: "+91 98765 43210" },
      { id: "2", number: "+91 98765 43211" },
      { id: "3", number: "+91 98765 43212" },
    ],
    Nigeria: [
      { id: "1", number: "+234 80123 45678" },
      { id: "2", number: "+234 80987 65432" },
      { id: "3", number: "+234 80765 43210" },
    ],
  };

  // Update phone numbers when country changes
  useEffect(() => {
    setPhoneNumbers(countryPhoneNumbers[country]);
    setSelectedNumber(""); // clear previously selected number
  }, [country]);

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 max-w-2xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Get Your Phone Number</h2>
      <p className="text-gray-600 mb-6">
        Choose a phone number from our available inventory to get started with
        voice calls.
      </p>

      {/* Country Select */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Country
        </label>
        <select
          value={country}
          onChange={(e) => setCountry(e.target.value)}
          className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        >
          <option>India</option>
          <option>Nigeria</option>
        </select>
      </div>

      {/* Phone Numbers */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Select Phone Number
        </label>
        <div className="space-y-3">
          {phoneNumbers.map((phone) => (
            <button
              key={phone.id}
              onClick={() => setSelectedNumber(phone.number)}
              className={`w-full p-4 border rounded-lg flex items-center transition-all ${
                selectedNumber === phone.number
                  ? "border-blue-600 bg-blue-50"
                  : "border-gray-300 hover:border-purple-300"
              }`}
            >
              <Phone className="w-5 h-5 text-[#7B7B7B] font-semibold mr-3" />
              <span className="font-medium">{phone.number}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Actions */}
      <div className="flex justify-between">
        <button className="px-6 py-2 text-gray-600 hover:text-gray-800">
          Back
        </button>
        <button
          onClick={() => selectedNumber && onContinue(selectedNumber)}
          disabled={!selectedNumber}
          className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
        >
          Continue
          <span className="ml-2">→</span>
        </button>
      </div>
    </div>
  );
};
